import { AlertBanner } from "../_shared/alert-banner";
import { CabinetHero } from "../_shared/cabinet-hero";
import { PageShell, Stack } from "../_shared/page-shell";
import { ALERT_MESSAGE } from "../_data/constants";
import { TodoCard } from "./todo.card";
import { PaymentsCard } from "./payments.card";
import { DocumentsCard } from "./documents.card";
import { AppointmentsCard } from "./appointments.card";
import { AlignersCard } from "./aligners.card";
import { PhotosCard } from "./photos.card";
import { ActionsCard } from "./actions.card";
import { TipsCard } from "./tips.card";

export function SummaryPage() {
  return (
    <>
      <CabinetHero title="Résumé" />
      <PageShell>
        <Stack>
          <AlertBanner message={ALERT_MESSAGE} />
          <TodoCard />

          <AppointmentsCard />

          <PaymentsCard />
          <DocumentsCard />

          <AlignersCard />

          <div className="grid gap-3 sm:gap-4 lg:grid-cols-2">
            <PhotosCard />
            <TipsCard />
          </div>

          <ActionsCard />
        </Stack>
      </PageShell>
    </>
  );
}
